import React, { useState } from 'react';
import { galleryImages } from '../mock';

export const GallerySection = ({ t }) => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const filteredImages = selectedCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  const categoryMap = {
    'all': 'Tous',
    'deer': 'Cerfs',
    'bear': 'Ours',
    'turkey': 'Dindons',
    'fishing': 'Pêche',
    'facilities': 'Installations'
  };

  return (
    <section id="gallery" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.gallery.title}
          </h2>
          <p className="text-xl text-orange-500 font-semibold mb-8">
            {t.gallery.subtitle}
          </p>

          {/* Category Filter */}
          <div className="flex flex-wrap justify-center gap-3">
            {Object.entries(categoryMap).map(([key, label]) => (
              <button
                key={key}
                onClick={() => setSelectedCategory(key)}
                className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${
                  selectedCategory === key
                    ? 'bg-orange-500 text-white shadow-lg'
                    : 'bg-stone-800 text-gray-300 hover:bg-stone-700 hover:text-white'
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {filteredImages.map((image) => (
            <div
              key={image.id}
              className="relative group overflow-hidden rounded-lg aspect-square cursor-pointer"
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
                <span className="text-white font-semibold">{image.alt}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
